import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";

const STORAGE_KEY = "chorki-message-toast-closed";

export default function ReferenceMessageToast() {
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(STORAGE_KEY)) setOpen(true);
  }, []);

  if (!open) return null;

  const title =
    lang === "en"
      ? "🔥 chorki mega offer – claim your bonus now!"
      : "🔥 chorki-এর মেগা অফার – এখনই বোনাস নিন!";

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  return (
    <div className="ref-message-toast" role="status" aria-live="polite">
      <button type="button" className="ref-message-toast-close" aria-label="Close message" onClick={close}>
        ×
      </button>
      <strong>New message</strong>
      <div className="ref-message-toast-row">
        <p>
          <span>Title:</span> {title}
        </p>
        <Link to="/promotion" onClick={close}>
          Go to
        </Link>
      </div>
    </div>
  );
}
